<template>
  <button
    @click="isAccountOpen = !isAccountOpen"
    ref="accountButton"
    class="ml-1"
  >
    <div class="flex cursor-pointer items-center">
      <img
        :src="user.avatar"
        alt="avatar"
        class="mr-[12px] size-[40px] grayscale"
      />
      <div class="flex flex-col items-start justify-center">
        <div
          class="text-lgmx_11 text-gpx_gray-100 min-w-[92px] max-w-[160px] self-start truncate"
          :title="accountTitle"
        >
          {{ accountTitle }}
        </div>
        <div
          class="text-lgmx_15 text-gpx_black-300 flex items-center font-medium"
        >
          <div class="mr-1">{{ name }}</div>
          <div>
            <ChevronDownIcon
              class="text-gpx_slate-700 size-[14px] translate-y-px transition-all duration-100"
              :class="[{ 'rotate-180': isAccountOpen }]"
            />
          </div>
        </div>
      </div>
    </div>
  </button>

  <button
    v-if="isAccountOpen"
    @click="isAccountOpen = false"
    class="hidden bg-transparent md:fixed md:inset-0 md:block"
  />

  <div
    class="border-gpx_gray-900 right-0 mx-5 rounded bg-white py-2 md:absolute md:top-full md:w-48 md:border"
    v-show="isAccountOpen"
  >
    <router-link
      to="/account"
      class="hover:bg-gpx_gray-900 hover:text-gpx_black-200 md:text-gpx_black-200 block p-2 text-black/50 md:px-6 md:py-1"
      block
    >
      My Profile
    </router-link>
    <button
      v-if="canSwitchAccounts"
      @click="openSwitchAccountModal"
      class="hover:bg-gpx_gray-900 hover:text-gpx_black-200 md:text-gpx_black-200 block w-full p-2 text-left text-black/50 md:px-6 md:py-1"
    >
      Switch Accounts
    </button>
    <VDivider class="my-2" />
    <button
      class="hover:bg-gpx_gray-900 hover:text-gpx_black-200 md:text-gpx_black-200 w-full p-2 text-left text-black/50 md:px-6 md:py-1"
      @click="handleLogout"
    >
      Logout
    </button>
  </div>
</template>

<script>
import * as _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import NProgress from 'nprogress';
import VDivider from '@/components/ui/VDivider.vue';

export default {
  components: {
    VDivider,
  },

  data() {
    return {
      isAccountOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      account: 'auth/account',
    }),
    name() {
      return _.get(this.user, 'name', 'No Name');
    },
    accountTitle() {
      return _.get(this.account, 'title', 'No Account');
    },
    canSwitchAccounts() {
      return this.user.accounts?.length > 1;
    },
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
      openModal: 'modal/open',
    }),
    openSwitchAccountModal() {
      this.openModal({ name: 'UserAccountSwitchModal' });
    },
    handleLogout() {
      NProgress.start();
      this.logout();
    },
  },
};
</script>

<style scoped>
a.router-link-active {
  @apply text-white bg-gpx_terracotta-200 hover:text-white;
}
</style>
